import React from 'react';
import { COMPANY_NAME, RETURN_POLICY_ADDRESS, CONTACT_EMAIL, PHONE_NUMBER } from '../constants';

const Footer: React.FC = () => {
  return (
    <footer id="contact" className="bg-gray-800 text-gray-300 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">{COMPANY_NAME}</h3>
            <p className="text-sm">
              Your trusted partner for 'Purchased on Premises' beverage labels.
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">Contact Us</h3>
            <p className="text-sm mb-1">Email: <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-emerald-400">{CONTACT_EMAIL}</a></p>
            <p className="text-sm">Phone: <a href={`tel:${PHONE_NUMBER}`} className="hover:text-emerald-400">{PHONE_NUMBER}</a></p>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">Our Address</h3>
            <address className="text-sm not-italic">
              {RETURN_POLICY_ADDRESS.name}<br />
              {RETURN_POLICY_ADDRESS.street}<br />
              {RETURN_POLICY_ADDRESS.city}, {RETURN_POLICY_ADDRESS.country}
            </address>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} {COMPANY_NAME}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
